import { Dispatcher as FluxDispatcher } from '../../../flux';

export function createDispatcher() {
  return new FluxDispatcher();
}

export { FluxDispatcher as Dispatcher };
